export const GET_ORGANIZATION_PROFILE = "GET_ORGANIZATION_PROFILE";
export const RESET_PROFILE_ACTION = "RESET_PROFILE_ACTION";
export const START_LOADING_ORGANIZATION = "START_LOADING_ORGANIZATION";
export const ERROR_LOADING_ORGANIZATION = "ERROR_LOADING_ORGANIZATION";
export const STOP_LOADING_ORGANIZATION = "STOP_LOADING_ORGANIZATION";